const toggleLanguages = (e) => {
    const $this = $(e.target);
    const $parent = $this.parents('.vtc-resource-languages');
    $this
      .find('.dashicons')
      .toggleClass('dashicons-arrow-down-alt2 dashicons-arrow-up-alt2');
    $parent.find('.other-languages').slideToggle();
};

export default toggleLanguages;
